import { ApiClient } from 'lib/api/ApiClient.types';
import { parseWithDecoratedError } from 'v4/entities/common/parseWithDecoratedError';
import { rowLevelValidation } from 'v5/platform/row-level-validation';
import { ReportTemplatesApi } from './reportTemplates.api';
import {
  reportExportResponse$,
  reportTemplate$,
  reportTemplateDraftToHttp,
  reportTemplateFromHttp,
  reportTemplatesListResponse$
} from './reportTemplates.http.schema';

export function createReportTemplatesApi(
  client: ApiClient
): ReportTemplatesApi {
  return {
    getTemplates: async signal => {
      const response = await client.get('/data_exports', {
        token: true,
        signal
      });
      const parsed = parseWithDecoratedError(
        reportTemplatesListResponse$,
        response
      );
      return rowLevelValidation.unsafeMapAll(
        parsed.results,
        reportTemplateFromHttp
      );
    },
    createTemplate: async draft => {
      const response = await client.post('/data_exports', {
        data: reportTemplateDraftToHttp(draft),
        token: true
      });
      return reportTemplateFromHttp(
        parseWithDecoratedError(reportTemplate$, response)
      );
    },
    updateTemplate: async (id, draft) => {
      const response = await client.put(`/data_exports/${id}`, {
        data: reportTemplateDraftToHttp(draft),
        token: true
      });
      return reportTemplateFromHttp(
        parseWithDecoratedError(reportTemplate$, response)
      );
    },
    setTemplateArchived: async (id, archived) => {
      const response = await client.put(`/data_exports/${id}`, {
        data: { archived },
        token: true
      });
      return reportTemplateFromHttp(
        parseWithDecoratedError(reportTemplate$, response)
      );
    },
    exportTemplate: async (id, { timezone, enterpriseWorkspaceId }) => {
      const response = await client.get(`/data_exports/${id}/export`, {
        token: true,
        params:
          enterpriseWorkspaceId === null
            ? { timezone }
            : { timezone, enterpriseWorkspaceId }
      });
      return parseWithDecoratedError(reportExportResponse$, response).data;
    }
  };
}
